// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button.is-plain[data-v-4eef6b9d]{--el-button-active-text-color:var(--el-color-primary);--el-button-active-border-color:var(--el-color-primary)}.el-button--primary.is-plain[data-v-4eef6b9d]{--el-button-border-color:var(--el-color-primary-light-3)}.el-link.el-link--primary[data-v-4eef6b9d]:hover{color:var(--el-color-primary-light-3)}[data-v-4eef6b9d] .el-link--inner{display:flex;justify-content:space-between;padding-bottom:10px}", ""]);
// Exports
module.exports = exports;
